import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { api } from "../utils/api";
import { t } from "../utils/i18n";

// Réseau "entre lieux Pro" (voir GET /venues/network/pro-events) : les Pro Events des AUTRES
// lieux Pro/Association, réservé à un admin/staff/propriétaire d'au moins un lieu Pro/Association
// soi-même — jamais pour un compte personnel classique. Accessible depuis l'onglet "Pro Events"
// de sa propre fiche lieu (voir src/pages/Venue.tsx).
export default function ProEventsNetwork() {
  const { lang } = useApp();
  const navigate = useNavigate();
  const [events, setEvents] = useState<any[] | null>(null);
  const [restricted, setRestricted] = useState(false);

  useEffect(() => {
    api.get("/venues/network/pro-events")
      .then(data => { setEvents(data?.events || []); setRestricted(false); })
      .catch(() => { setEvents([]); setRestricted(true); });
  }, []);

  return (
    <div style={{ maxWidth: 700, margin: "0 auto", padding: 20 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
        <button onClick={() => navigate(-1)} style={{ border: "none", background: "none", cursor: "pointer", fontSize: 20, color: "#666" }}>←</button>
        <span style={{ fontSize: 20, fontWeight: 700 }}>{t(lang, "pro_events_network_title")}</span>
      </div>

      {events === null ? (
        <div style={{ textAlign: "center", color: "#999", fontSize: 13, padding: 40 }}>Chargement…</div>
      ) : restricted ? (
        <div style={{ textAlign: "center", color: "#999", fontSize: 13, padding: 40 }}>{t(lang, "pro_events_network_restricted")}</div>
      ) : events.length === 0 ? (
        <div style={{ textAlign: "center", color: "#999", fontSize: 13, padding: 40 }}>{t(lang, "pro_events_network_empty")}</div>
      ) : (
        events.map(event => (
          <div key={event.id} style={{ backgroundColor: "white", border: "1px solid #F0F0F0", borderRadius: 14, overflow: "hidden", marginBottom: 14 }}>
            <div onClick={() => navigate(`/publication/${event.id}`)} style={{ height: 130, background: event.cover_url ? `url(${event.cover_url}) center/cover` : "linear-gradient(135deg, #1a1a1a, #0a0a0a)", position: "relative", padding: 12, cursor: "pointer" }}>
              <div style={{ position: "absolute", top: 12, left: 12, backgroundColor: "#9ACD32", borderRadius: 20, padding: "3px 10px" }}>
                <span style={{ color: "#0a0a0a", fontSize: 12, fontWeight: 600 }}>{(event.is_free || Number(event.price) === 0) ? t(lang, "venue_free") : `${event.price}€/pers`}</span>
              </div>
              {event.max_places && (
                <div style={{ position: "absolute", top: 12, right: 12, backgroundColor: "rgba(0,0,0,0.4)", borderRadius: 20, padding: "3px 8px" }}>
                  <span style={{ color: "white", fontSize: 11 }}>{event.max_places - (event.current_places || 0)} {t(lang, "venue_places_suffix")}</span>
                </div>
              )}
              <div style={{ position: "absolute", bottom: 12, left: 12, right: 12 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 3 }}>
                  {!!event.venue_avatar && <img src={event.venue_avatar} alt="" style={{ width: 16, height: 16, borderRadius: 8, objectFit: "cover" }} />}
                  <span style={{ color: "rgba(255,255,255,0.85)", fontSize: 11, fontWeight: 600 }}>{event.venue_name}</span>
                </div>
                <div style={{ color: "white", fontWeight: 700, fontSize: 14 }}>{event.title}</div>
                {event.event_date && <div style={{ color: "rgba(255,255,255,0.8)", fontSize: 12, marginTop: 2 }}>{new Date(event.event_date).toLocaleString(lang, { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })}</div>}
                {Array.isArray(event.collaborators) && event.collaborators.length > 0 && (
                  <div style={{ color: "rgba(255,255,255,0.8)", fontSize: 12, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{t(lang, "pro_event_co_organized_with")} {event.collaborators.map((c: any) => c.name).join(", ")}</div>
                )}
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
}
